import React from 'react';
import { Skeleton } from './ui/skeleton';
import { Card } from './ui/card';
import { AlertCircle, Inbox } from 'lucide-react';
import { Button } from './ui/button';

export const PageHeader = ({ title, description, actions }) => (
  <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
    <div>
      <h1 className="font-display text-2xl font-semibold tracking-tight text-foreground">{title}</h1>
      {description && <p className="text-sm text-muted-foreground mt-1">{description}</p>}
    </div>
    {actions && <div className="flex items-center gap-2">{actions}</div>}
  </div>
);

export const LoadingKpis = ({ count = 8 }) => (
  <div className="grid grid-cols-12 gap-4" data-testid="loading-kpi-skeleton">
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="col-span-12 sm:col-span-6 xl:col-span-3"><Skeleton className="h-[104px] w-full rounded-xl" /></div>
    ))}
  </div>
);

export const LoadingTable = () => (
  <div className="space-y-2" data-testid="loading-table-skeleton">
    <Skeleton className="h-10 w-full rounded-lg" />
    {Array.from({ length: 6 }).map((_, i) => <Skeleton key={i} className="h-12 w-full rounded-lg" />)}
  </div>
);

export const EmptyState = ({ title = 'Nessun dato', description, action }) => (
  <Card className="flex flex-col items-center justify-center text-center py-16 px-6" data-testid="empty-state">
    <Inbox className="h-10 w-10 text-muted-foreground mb-3" />
    <h3 className="font-medium text-foreground">{title}</h3>
    {description && <p className="text-sm text-muted-foreground mt-1 max-w-md">{description}</p>}
    {action && <div className="mt-4">{action}</div>}
  </Card>
);

export const ErrorState = ({ message = 'Errore nel caricamento', onRetry }) => (
  <Card className="flex flex-col items-center justify-center text-center py-16 px-6" data-testid="error-state">
    <AlertCircle className="h-10 w-10 text-destructive mb-3" />
    <h3 className="font-medium text-foreground">{message}</h3>
    {onRetry && <Button variant="outline" className="mt-4" onClick={onRetry} data-testid="error-retry-button">Riprova</Button>}
  </Card>
);
